"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _uploader = _interopRequireDefault(require("./uploader"));

var _compact_props = _interopRequireDefault(require("./utils/compact_props"));

var _no_value_component = _interopRequireDefault(require("./component/fileuploader/no_value_component"));

var _status_component = _interopRequireDefault(require("./component/fileuploader/status_component"));

var _index = require("./utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var FileUploader =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FileUploader, _PureComponent);

  /**
   * 属性说明
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基础属性
   * @property {bool} [disabled=false] 是否禁用
   * @property {bool} [multiple=false] 是否多选
   * @property {string} [helpBlock=''] 提示文案
   * @property {bool} [reupload=true] 是否支持重新上传
   * @property {string} [uploadText='本地上传'] 上传按钮文案
   * @property {string} [reuploadText='重新上传'] 重新上传按钮文案
   * @property {string} [fileId] 指定"input type=file"的id
   * @property {bool} [autoUpload=true] 是否自动上传
   * @property {string} [accept='*'] 选择的文件类型*（<a href="https://developer.mozilla.org/zh-CN/docs/Web/HTTP/Headers/Accept" target="_blank">参考配置</a>）*
   * @property {func} [onFileChange] 文件变化即调用*onFileChange=(event)*
   * @property {titleline} 已上传数据属性
   * @property {object} [value={}] 已经上传的数据*value={url, name, status}*
   * @property {bool} [canDelete=true] 是否支持删除
   * @property {func} [onDelete] 数据删除回调*onDelete=(event)*
   * @property {titleline} 触发上传属性
   * @property {string} [name=''] 字段名
   * @property {string} [url=''] 上传的url
   * @property {object} [data={}] 接口附带的数据
   * @property {object} [headers={}] 请求header参数
   * @property {func} [filter] 筛选文件（只适用于支持html5的）<br />filter(fileInfo, event)
   * @property {func} [check] 异步文件检查成功后，调用next继续上传<br />check(fileInfo, next) 检查成功后，调用next继续上传
   * @property {func} [canUpload] 是否能够触发上传<br />canUpload(event)
   * @property {func} [onUpload] 开始上传回调<br />onUpload(event, fileInfo)
   * @property {func} [onProgress] 上传过程回调<br />onProgress(progressEvent, fileInfo)
   * @property {func} [onComplete] 上传完成回调<br />onComplete(resp, fileInfo)
   * @property {titleline} 自定义属性
   * @property {func|element} [StatusComponent] 文件上传显示结构文件上传显示结构
   * @example
   *  &lt;StatusComponent
   name={name}
   status={status}
   progress={progress}
   setUploader={this.setUploader}
   onDelete={this.handleDelete}
   reupload={reupload}
   deleteable={canDelete}
   canDelete={canDelete}
   reuploadText={reuploadText}
  /&gt;
   */
  function FileUploader(props) {
    var _this;

    _classCallCheck(this, FileUploader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileUploader).call(this, props));

    _this.nullList();

    _this.handleUpload = _this.handleUpload.bind(_assertThisInitialized(_this));
    _this.handleProgress = _this.handleProgress.bind(_assertThisInitialized(_this));
    _this.handleComplete = _this.handleComplete.bind(_assertThisInitialized(_this));
    _this.handleDelete = _this.handleDelete.bind(_assertThisInitialized(_this));
    _this.hanldeFileChange = _this.hanldeFileChange.bind(_assertThisInitialized(_this));
    _this.setUploader = _this.setUploader.bind(_assertThisInitialized(_this));
    _this.id = (0, _index.uniqueId)();
    _this.emptyId = _this.id + '-empty';
    _this.statusId = _this.id + '-status';
    var _props$value = props.value,
        value = _props$value === void 0 ? {} : _props$value;
    _this.state = {
      name: value.name || '',
      status: value.status || '',
      progress: value.progress || 0
    };
    return _this;
  }

  _createClass(FileUploader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setValueStatus();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _nextProps$value = nextProps.value,
          value = _nextProps$value === void 0 ? {} : _nextProps$value;

      if ((0, _index.isEmptyObject)(value)) {
        this.setState({
          status: '',
          progress: 0,
          name: ''
        });
      } else {
        if (typeof value.name !== 'undefined') {
          this.setState({
            name: value.name
          });
        }

        if (typeof value.status !== 'undefined') {
          this.setState({
            status: value.status
          });
        }

        if (typeof value.progress !== 'undefined') {
          this.setState({
            progress: value.progress
          });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setValueStatus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.domRef = null;
      this.uploadRef = null;
    }
  }, {
    key: "setStatusClassName",
    value: function setStatusClassName() {
      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var result = (0, _classnames["default"])({
        'fail': status === 'fail',
        'success': status === 'success',
        'ready': status === 'ready',
        'uploading': status === 'uploading',
        'default': !status
      });

      if (this.domRef) {
        (0, _spauiUtils.removeClassName)(this.domRef, 'fail');
        (0, _spauiUtils.removeClassName)(this.domRef, 'success');
        (0, _spauiUtils.removeClassName)(this.domRef, 'uploading');
        (0, _spauiUtils.removeClassName)(this.domRef, 'ready');
        (0, _spauiUtils.removeClassName)(this.domRef, 'default');
        (0, _spauiUtils.addClassName)(this.domRef, result);
      }

      return result;
    } // 开始上传

  }, {
    key: "handleUpload",
    value: function handleUpload(event, fileInfo) {
      var _this2 = this;

      var notUpload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props = this.props,
          onUpload = _this$props.onUpload,
          autoUpload = _this$props.autoUpload,
          _this$props$uploading = _this$props.uploadingText,
          uploadingText = _this$props$uploading === void 0 ? '' : _this$props$uploading;
      var infoData = {
        name: fileInfo.name || uploadingText,
        status: 'ready',
        progress: 0
      };

      if (autoUpload) {
        this.setState(infoData);
      } else if (notUpload) {
        var $emptyDom = null,
            $statusDom = null,
            $statusName = null,
            $uploadDom = null;
        $emptyDom = (0, _index.getId)(this.emptyId);
        $statusDom = (0, _index.getId)(this.statusId);
        $statusName = (0, _index.getId)(this.statusId + '-label');
        $uploadDom = (0, _index.getId)(this.statusId + '-upload');
        this.setStatusClassName('ready');

        if ($emptyDom) {
          $emptyDom.style.display = 'none';
        }

        if ($statusDom) {
          $statusDom.style.display = '';
        }

        if ($statusName) {
          $statusName.innerHTML = infoData.name;
        }

        if ($uploadDom) {
          $uploadDom.onclick = function () {
            if (_this2.uploadRef && _this2.uploadRef.inputRef) {
              _this2.uploadRef.inputRef.click();
            }
          };
        }
      }

      if ((0, _spauiUtils.isFunction)(onUpload)) {
        onUpload(event, fileInfo);
      }
    } // 进度

  }, {
    key: "handleProgress",
    value: function handleProgress(event, item) {
      var onProgress = this.props.onProgress;
      this.setState({
        status: 'uploading',
        progress: event.loaded / event.total * 100
      });

      if ((0, _spauiUtils.isFunction)(onProgress)) {
        onProgress(event, item);
      }
    } // 完成

  }, {
    key: "handleComplete",
    value: function handleComplete(err, xhr) {
      var resp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var fileTarget = arguments.length > 3 ? arguments[3] : undefined;
      var fileId = arguments.length > 4 ? arguments[4] : undefined;
      var onComplete = this.props.onComplete;
      this.setState({
        progress: 100
      });

      if ((0, _spauiUtils.isFunction)(onComplete)) {
        onComplete(resp, fileTarget, fileId, xhr);
      }
    } // 删除文件

  }, {
    key: "handleDelete",
    value: function handleDelete(event) {
      var _this$props2 = this.props,
          onDelete = _this$props2.onDelete,
          autoUpload = _this$props2.autoUpload;

      if (autoUpload) {
        this.setState({
          name: '',
          status: '',
          progress: 0
        });
      } else {
        var $emptyDom = null,
            $statusDom = null;
        $emptyDom = (0, _index.getId)(this.emptyId);
        $statusDom = (0, _index.getId)(this.statusId);
        this.setStatusClassName();

        if ($emptyDom) {
          $emptyDom.style.display = '';
        }

        if ($statusDom) {
          $statusDom.style.display = 'none';
        }

        if (this.uploadRef && this.uploadRef.inputRef) {
          this.uploadRef.inputRef.value = '';
        }
      }

      if ((0, _spauiUtils.isFunction)(onDelete)) {
        onDelete(event);
      }

      event.stopPropagation();
    } // 获取input type=file

  }, {
    key: "getInputDOMNode",
    value: function getInputDOMNode() {
      var result = null;

      if (this.uploadRef) {
        result = this.uploadRef.getInputDOMNode();
      }

      return result;
    }
  }, {
    key: "startUpload",
    value: function startUpload() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var headers = arguments.length > 1 ? arguments[1] : undefined;

      if (this.uploadRef) {
        this.uploadRef.startUpload(data, headers);
      }
    }
  }, {
    key: "hanldeFileChange",
    value: function hanldeFileChange(event) {
      var _this3 = this;

      var _this$props3 = this.props,
          onFileChange = _this$props3.onFileChange,
          autoUpload = _this$props3.autoUpload;
      var getFiles = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && _typeof(window.FileAPI) === 'object' && window.FileAPI.getFiles;
      var files = getFiles ? getFiles(event) : [];
      var filename = '',
          $emptyDom = null,
          $statusDom = null,
          $statusName = null,
          $uploadDom = null;

      if (!autoUpload) {
        // 获取文件名
        if (files && files.length > 0 && files[0].name) {
          filename = files[0].name;

          if (files.length > 1) {
            filename = filename + '...' + files.length + '个文件';
          }
        } else {
          // 不选择文件，关闭文件选择框
          return;
        } // 获取对应的结构


        $emptyDom = (0, _index.getId)(this.emptyId);
        $statusDom = (0, _index.getId)(this.statusId);
        $statusName = (0, _index.getId)(this.statusId + '-label');
        $uploadDom = (0, _index.getId)(this.statusId + '-upload');
        this.setStatusClassName('ready');

        if ($emptyDom) {
          $emptyDom.style.display = 'none';
        }

        if ($statusDom) {
          $statusDom.style.display = '';
        }

        if ($statusName) {
          $statusName.innerHTML = filename;
        }

        if ($uploadDom) {
          $uploadDom.onclick = function () {
            if (_this3.uploadRef && _this3.uploadRef.inputRef) {
              _this3.uploadRef.inputRef.click();
            }
          };
        }
      }

      if ((0, _spauiUtils.isFunction)(onFileChange)) {
        onFileChange(event);
      }
    }
  }, {
    key: "setValueStatus",
    value: function setValueStatus() {
      var _this4 = this;

      var _this$props4 = this.props,
          autoUpload = _this$props4.autoUpload,
          _this$props4$uploadin = _this$props4.uploadingText,
          uploadingText = _this$props4$uploadin === void 0 ? '' : _this$props4$uploadin;
      var $emptyDom = null,
          $statusDom = null,
          $statusName = null,
          $uploadDom = null;

      if (this.domRef && !autoUpload) {
        // 获取对应的结构
        $emptyDom = (0, _index.getId)(this.emptyId);
        $statusDom = (0, _index.getId)(this.statusId);
        $statusName = (0, _index.getId)(this.statusId + '-label');
        $uploadDom = (0, _index.getId)(this.statusId + '-upload');
        this.setStatusClassName(this.state.status);

        if (this.state.status) {
          if ($emptyDom) {
            $emptyDom.style.display = 'none';
          }

          if ($statusDom) {
            $statusDom.style.display = '';
          }
        }

        if ($statusName && this.state.name) {
          if (this.state.status === 'uploading') {
            $statusName.innerHTML = uploadingText;
          } else {
            $statusName.innerHTML = this.state.name;
          }
        }

        if ($uploadDom) {
          $uploadDom.onclick = function () {
            if (_this4.uploadRef && _this4.uploadRef.inputRef) {
              _this4.uploadRef.inputRef.click();
            }
          };
        }
      }
    } // 设置上传节点

  }, {
    key: "setUploader",
    value: function setUploader(children, config) {
      var _this5 = this;

      var _this$props5 = this.props,
          name = _this$props5.name,
          url = _this$props5.url,
          multiple = _this$props5.multiple,
          disabled = _this$props5.disabled,
          filter = _this$props5.filter,
          canUpload = _this$props5.canUpload,
          autoUpload = _this$props5.autoUpload,
          data = _this$props5.data,
          click = _this$props5.click,
          accept = _this$props5.accept,
          check = _this$props5.check,
          fileId = _this$props5.fileId,
          headers = _this$props5.headers,
          _this$props5$FileAPIC = _this$props5.FileAPIConfig,
          FileAPIConfig = _this$props5$FileAPIC === void 0 ? {} : _this$props5$FileAPIC;
      var props = (0, _spauiUtils.objectAssign)({
        disabled: disabled,
        multiple: multiple,
        drag: false,
        name: name,
        url: url,
        data: data,
        filter: filter,
        click: click,
        accept: accept,
        autoUpload: autoUpload,
        canUpload: canUpload,
        onFileChange: this.hanldeFileChange,
        onProgress: this.handleProgress,
        onUpload: this.handleUpload,
        onComplete: this.handleComplete,
        check: check,
        fileId: fileId,
        headers: headers,
        FileAPIConfig: FileAPIConfig
      }, config);
      return _react["default"].createElement(_uploader["default"], _extends({}, props, {
        ref: function ref(el) {
          _this5.uploadRef = el;
        }
      }), children);
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this$props6 = this.props,
          children = _this$props6.children,
          uploadText = _this$props6.uploadText;
      var NoValueComponent = _no_value_component["default"];
      var result = null;

      if (children) {
        try {
          result = (0, _react.cloneElement)(children, {
            id: this.emptyId
          });
        } catch (e) {
          result = children;
        }
      } else {
        result = _react["default"].createElement(NoValueComponent, {
          id: this.emptyId,
          uploadText: uploadText
        });
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props7 = this.props,
          StatusComponent = _this$props7.StatusComponent,
          helpBlock = _this$props7.helpBlock,
          reupload = _this$props7.reupload,
          autoUpload = _this$props7.autoUpload,
          _this$props7$value = _this$props7.value,
          value = _this$props7$value === void 0 ? {} : _this$props7$value,
          _this$props7$reupload = _this$props7.reuploadText,
          reuploadText = _this$props7$reupload === void 0 ? '' : _this$props7$reupload,
          _this$props7$uploadin = _this$props7.uploadingText,
          uploadingText = _this$props7$uploadin === void 0 ? '' : _this$props7$uploadin;
      var canDelete = (0, _compact_props["default"])(this.props);
      var _this$state = this.state,
          progress = _this$state.progress,
          stateStatus = _this$state.status,
          stateName = _this$state.name;
      var status = value.status && !stateStatus ? value.status : stateStatus || '';
      var name = value.name && !stateName ? value.name : stateName || '';
      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        supportAllEvents: true,
        className: (0, _classnames["default"])('spaui-upfile', this.setStatusClassName(status))
      }, FileUploader, this.props), {
        ref: function ref(el) {
          _this6.domRef = el;
        }
      }), !status || !name ? this.setUploader(this.getChildren()) : _react["default"].createElement(StatusComponent, {
        uploadingText: uploadingText,
        id: this.statusId,
        name: name,
        status: status,
        progress: progress,
        setUploader: this.setUploader,
        onDelete: this.handleDelete,
        reupload: reupload,
        deleteable: canDelete,
        canDelete: canDelete,
        reuploadText: reuploadText
      }), !autoUpload && !name ? _react["default"].createElement(StatusComponent, {
        uploadingText: uploadingText,
        id: this.statusId,
        style: {
          display: 'none'
        },
        name: name,
        status: status,
        progress: progress,
        onDelete: this.handleDelete,
        reupload: reupload,
        deleteable: canDelete,
        canDelete: canDelete,
        reuploadText: reuploadText
      }) : null, helpBlock ? _react["default"].createElement("p", {
        className: "spaui-upfile-help-block"
      }, helpBlock) : null);
    }
  }]);

  return FileUploader;
}(_react.PureComponent);

_defineProperty(FileUploader, "propTypes", {
  name: _spauiUtils.PropTypes.string,
  url: _spauiUtils.PropTypes.string,
  data: _spauiUtils.PropTypes.object,
  headers: _spauiUtils.PropTypes.object,
  disabled: _spauiUtils.PropTypes.bool,
  multiple: _spauiUtils.PropTypes.bool,
  accept: _spauiUtils.PropTypes.string,
  filter: _spauiUtils.PropTypes.func,
  check: _spauiUtils.PropTypes.func,
  value: _spauiUtils.PropTypes.object,
  helpBlock: _spauiUtils.PropTypes.string,
  reupload: _spauiUtils.PropTypes.bool,
  uploadText: _spauiUtils.PropTypes.string,
  reuploadText: _spauiUtils.PropTypes.string,
  canDelete: _spauiUtils.PropTypes.bool,
  autoUpload: _spauiUtils.PropTypes.bool,
  onUpload: _spauiUtils.PropTypes.func,
  onProgress: _spauiUtils.PropTypes.func,
  onComplete: _spauiUtils.PropTypes.func,
  onDelete: _spauiUtils.PropTypes.func,
  onFileChange: _spauiUtils.PropTypes.func,
  uploadingText: _spauiUtils.PropTypes.string,
  StatusComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element])
});

_defineProperty(FileUploader, "defaultProps", {
  name: '',
  url: '',
  data: {},
  headers: {},
  disabled: false,
  multiple: false,
  accept: '*',
  filter: function filter() {
    return true;
  },
  value: {},
  helpBlock: '',
  reupload: true,
  uploadText: '本地上传',
  reuploadText: '重新上传',
  canDelete: true,
  autoUpload: true,
  uploadingText: '文件上传中',
  StatusComponent: _status_component["default"]
});

var _default = FileUploader;
exports["default"] = _default;